import { render, staticRenderFns } from "./select-label.vue?vue&type=template&id=a89f91e4&scoped=true"
import script from "./select-label.vue?vue&type=script&lang=js"
export * from "./select-label.vue?vue&type=script&lang=js"
import style0 from "./select-label.vue?vue&type=style&index=0&id=a89f91e4&scoped=true&lang=scss"
import style1 from "./select-label.vue?vue&type=style&index=1&id=a89f91e4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f91e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a89f91e4')) {
      api.createRecord('a89f91e4', component.options)
    } else {
      api.reload('a89f91e4', component.options)
    }
    module.hot.accept("./select-label.vue?vue&type=template&id=a89f91e4&scoped=true", function () {
      api.rerender('a89f91e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-common/select-label.vue"
export default component.exports